import { gql } from "@apollo/client";

export const USER_POOL_GET_REFERRAL_SATS = gql`
  query GetReferralSats {
    referralSats: getReferralSats
  }
`;
